import { FundraisingProps, renderHasChanged } from 'src/components/Pages/AddFundraisingPage';
import { useAppDispatch } from 'src/redux/Store';
import { MouseEvent, useState } from 'react';
import Subtitle from 'src/components/UI/Subtitle';
import FormRichTextEditor from 'src/components/Control/FormControls/FormRichTextEditor';
import { FORM } from 'src/constants/Form';
import { FundraisingModel, Step, TABS } from 'src/models/FundraisingModel';
import BottomRow from 'src/components/UI/BottomRow';
import Button from '@material-ui/core/Button';
import { setError } from 'src/redux/actions/errorsActions';

const FundraisingMessageForm = (props: FundraisingProps) => {
  const dispatch = useAppDispatch();

  const {
    onChange,
    setErrors,
    fundraisingState,
    setHasChanged,
    hasChanged,
  } = props;

  const [message, setMessage] = useState(fundraisingState.assets as string);

  const onMessageChange = (value: string) => {
    setMessage(value);
    setHasChanged(true);
    setErrors(TABS.assets, true);
  };

  const handleSubmit = (event: MouseEvent<HTMLElement>, advance: boolean) => {
    event.preventDefault();
    dispatch(setError({ [FORM.fundraising]: {} }));
    setErrors(TABS.assets, false);
    onChange(
      {
        ...fundraisingState,
        assets: message,
      } as FundraisingModel,
      Step.assets,
      advance,
    );
  };

  return (
    <>
      <Subtitle style={{ marginTop: '8px' }}>
        Fundraising Message
      </Subtitle>
      <div style={{ padding: '16px 48px' }}>
        <FormRichTextEditor
          form={FORM.fundraising}
          name="messages"
          onChange={(value: string) => { onMessageChange(value); }}
          value={message} />
      </div>
      <BottomRow>
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => handleSubmit(e, false)}
          key="submit-button">
          Save{renderHasChanged(!hasChanged)}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => handleSubmit(e, true)}
          key="submit-button">
          Save{renderHasChanged(!hasChanged)} and Next Step
        </Button>
      </BottomRow>
    </>
  );
};

export default FundraisingMessageForm;
